// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3VT01","university-logo":"Navbar_university-logo__gLK7X","navbar-responsive":"Navbar_navbar-responsive__1omhr"};